import { useMutation } from '@apollo/client';
import RequiresAuth from '@website/components/auth/RequiresAuth';
import { HostProfileForm } from '@website/components/hosts/signupForms/hostProfileForm';
import ErrorPage from '@website/components/utilities/ErrorPage';
import {
  CreateHostProfileDocument,
  HostProfileInput,
} from '@website/types/graphqlOperations';
import Router from 'next/router';
import { Col, Container, Row } from 'react-bootstrap';
import { Auth } from '@aws-amplify/auth';

/**
 * requestUserTokenRefresh
 *
 * When a host signs up, request AWS Cognito via Amplify to refresh the token so
 * that the new host role can be added to their ID token and they can be able to
 * immediately manage their host.
 *
 */
export async function requestUserSessionRefresh() {
  const currentUser = await Auth.currentAuthenticatedUser();
  const currentSession = await Auth.currentSession();
  const data = await new Promise((resolve, reject) => {
    currentUser.refreshSession(
      (currentSession as any).refreshToken,
      (err, session) => {
        if (err) {
          return reject(err);
        }
        return resolve(session);
      },
    );
  });
  return data;
}

export default function HostProfilePage() {
  const [createProfile, { loading, error }] = useMutation(
    CreateHostProfileDocument,
  );

  async function onSubmit(formData: HostProfileInput) {
    const { data, errors } = await createProfile({
      variables: {
        profile: formData,
      },
    });
    if (!errors) {
      await requestUserSessionRefresh();
      const hostUrl = data.createHostProfile.urlSlug;
      Router.push(`/hosts/dashboard/${hostUrl}`);
    }
  }

  if (error) {
    return <ErrorPage />;
  }

  return (
    <RequiresAuth>
      <Container className="p-4">
        <Row>
          <Col>
            <h3 className="h3 mb-5">Apply to host your Trips on Skyhook</h3>
            <HostProfileForm onSubmit={onSubmit} isLoading={loading} />
          </Col>
        </Row>
      </Container>
    </RequiresAuth>
  );
}
